import SettlementHeader from "../statement-header/SettlementHeader";

export default function HeaderContainer({ onDownloadPdf, disableDownloadPdf }) {
  return (
    <SettlementHeader
      onDownloadPdf={onDownloadPdf}
      disableDownloadPdf={disableDownloadPdf}
    />
  );
}
